export const FAITH_TRADITIONS = Object.freeze({
  CHRISTIAN: 'christian',
  JEWISH: 'jewish',
  ISLAMIC: 'islamic',
  BUDDHIST: 'buddhist',
  HINDU: 'hindu',
  GENERAL_SPIRITUAL: 'general_spiritual',
  ANCESTRAL_LINEAGE: 'ancestral_lineage',
  CHAKRA_ALIGNED: 'chakra_aligned'
});

export const FAITH_TRADITION_OPTIONS = Object.freeze([
  { value: FAITH_TRADITIONS.CHRISTIAN, label: 'Christian' },
  { value: FAITH_TRADITIONS.JEWISH, label: 'Judaism' },
  { value: FAITH_TRADITIONS.ISLAMIC, label: 'Islam' },
  { value: FAITH_TRADITIONS.BUDDHIST, label: 'Buddhist' },
  { value: FAITH_TRADITIONS.HINDU, label: 'Hindu' },
  { value: FAITH_TRADITIONS.GENERAL_SPIRITUAL, label: 'General Spiritual' },
  { value: FAITH_TRADITIONS.ANCESTRAL_LINEAGE, label: 'Ancestral & Lineage' },
  { value: FAITH_TRADITIONS.CHAKRA_ALIGNED, label: 'Chakra-Aligned' }
]);
